const func = $target => {

	window.loader.key('annotorious', function() {

		// jQuery.noConflict();
		console.log('annotorious loaded');

		var $uid = $target.data('uid'),
			$cid = $target.data('cid'),
			type = 'comment';
		
		anno.makeAnnotatable(document.querySelectorAll("[data-id='annotatable']")[0]);

		anno.addHandler('onAnnotationCreated', function(annotation) {

			console.log('onAnnotationCreated');
			annotation.context=annotation.context.split("?")[0]; // if the item page has querystring parameters, this causes the JSON.parse to fail on the server, so just strip them off here

			$.ajax({
				type: "POST",
				dataType: "json",
				url: "/actions/twilio/media/save-annotation",
				headers: {
					"X-CSRF-Token" : window.csrfTokenValue,
				},
				data: {
					uid:$uid,
					cid:$cid,
					type:type,
					data:annotation
				}
			}).done(function(data) {
				annotation.id = data.id;
				annotation.username = data.username
				annotation.dateUpdated = data.dateUpdated
			});

		});

		anno.addHandler('onAnnotationRemoved', function(annotation) {

			console.log(annotation.id)
			$.ajax({
				type: "POST",
				dataType: "json",
				url: "/actions/twilio/media/delete-annotation",
				headers: {
					"X-CSRF-Token" : window.csrfTokenValue,
				},
				data: {id:annotation.id}
			}).done(function(data) {

			});
		});

		anno.addHandler('onAnnotationUpdated', function(annotation) {
			$.ajax({
				type: "POST",
				dataType: "json",
				url: "/actions/twilio/media/save-annotation",
				headers: {
					"X-CSRF-Token" : window.csrfTokenValue,
				},
				data: {
					uid:$uid,
					cid:$cid,
					type:type,
					data:annotation
				}
			}).done(function(data) {
				// annotation.id = data.id;
				// annotation.username = $username
			});
		});	

		loadAnnotations($uid);

		function loadAnnotations(uid) {
			uid = typeof uid !== 'undefined' ? uid : 0;

			$.ajax({
				url: '/actions/twilio/media/get-comments',
				dataType: 'json',
				data: {
					uid: uid,
				}
			}).done(function(response) {
				// console.log(response);
				$.each(response, function() {

					var data = this;

					data.shapes[0].geometry.y = parseFloat(data.shapes[0].geometry.y);
					data.shapes[0].geometry.x = parseFloat(data.shapes[0].geometry.x);
					data.shapes[0].geometry.width = parseFloat(data.shapes[0].geometry.width);
					data.shapes[0].geometry.height = parseFloat(data.shapes[0].geometry.height);

					// console.log(data);

					anno.addAnnotation(data);
				})
			});
		}

		//  add username and date
		annotorious.plugin.addUsernamePlugin = function(opt_config_options) { }
		annotorious.plugin.addUsernamePlugin.prototype.onInitAnnotator = function(annotator) {
			annotator.popup.addField(function(annotation) {

				if (annotation.username != '') {
					return '<em>' + annotation.username + ' - '+ annotation.dateUpdated +'</em>'
				} else {
					return ''
				}

			});
		}

		anno.addPlugin('addUsernamePlugin', {});

	});

	window.loader.key('markerjs', function() {

		console.log('marker js loaded');

		var $uid = $target.data('uid'),
			$cid = $target.data('cid'),
			$markerOpen = $target.find('[data-id="marker-open"]'),
			$markerClose = $target.find('[data-id="marker-close"]'),
			img = document.querySelectorAll("[data-id='annotatable']")[0],
			type = 'annotation',
			markerArea = '',
			previousState = '',
			renderedImage = '';

		//load any existing annotation
		$.ajax({
			url: '/actions/twilio/media/get-annotations',
			dataType: 'json',
			data: {
				uid:$uid,
				imageWidth:img.width,
			}
		}).done(function(response) {

			if(response) {
				previousState = response[0];						
			}

			markerArea = new markerjs.MarkerArea(img, {
				previousState: previousState
			});

			markerArea.open();			
			markerArea.render(function(dataUrl) {
				renderedImage = dataUrl;
				img.src = renderedImage;
			});
			markerArea.close();

		});

		$markerOpen.on('click',function() {

			var $this = $(this);

			// $this.attr('disabled',true);
			img.src = img.dataset.image;
			markerArea = new markerjs.MarkerArea(img, {
				previousState: previousState
			});

			markerArea.show(function(dataUrl,state) {
				renderedImage =	dataUrl;
				img.src = renderedImage;
				previousState = state;

				console.log('save');			
				
			
				previousState.imageSize = {};
				previousState.imageSize.width = img.width;
				previousState.imageSize.height = img.height;

				console.log(previousState);

				// console.log(previousState.imageSize.width);

				$.ajax({
					type: "POST",
					dataType: "json",
					url: "/actions/twilio/media/save-annotation",
					headers: {
						"X-CSRF-Token" : window.csrfTokenValue,
					},
					data: {
						uid:$uid,
						cid:$cid,
						type:type,
						data:previousState
					}
				}).done(function(data) {
					
				});					

				// $('.markerjs-toolbar-button[title="close"]').on('click',function() {
				// 	console.log('close');
				// 	// $this.attr('disabled',false);
				// })

			});	

			$this.addClass('d-none');
			$markerClose.removeClass('d-none');

			// $this.html('Enable Comments').data('id','marker-close');
		});

		$markerClose.on('click',function() {
			markerArea.close();
			img.src=renderedImage;
			$(this).addClass('d-none');
			$markerOpen.html('Enable Annotation').removeClass('d-none');
		});	

		$('body').on('click', '.markerjs-toolbar-button[title="OK"]', function() {
			$markerClose.addClass('d-none');
			$markerOpen.html('Enable Annotation').removeClass('d-none');
		});


	// end key

	});

}

export default func;